var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.56315 -0.00390625H13.0251L18.0049 5.03168V19.4462C18.0049 19.7545 17.7549 20.0045 17.4466 20.0045H2.56315C2.25483 20.0045 2.00488 19.7545 2.00488 19.4462V0.554363C2.00488 0.246042 2.25483 -0.00390625 2.56315 -0.00390625Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0249 -0.00390625V4.47341C13.0249 4.78173 13.2749 5.03168 13.5832 5.03168H18.0047L13.0249 -0.00390625Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7458 15.7569C14.1899 16.2433 15.0001 15.9291 15.0001 15.2704V7.60156H13.5571V13.41L10.6884 10.2681C10.4023 9.95476 9.90887 9.95476 9.62275 10.2681L6.75409 13.41V7.60156H5.31104V15.2704C5.31104 15.9291 6.12125 16.2434 6.5654 15.7569L10.1556 11.8247L13.7458 15.7569Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.81c298a421ff25ebb7060810d20c5de6.svg";
export { ForwardRef as ReactComponent };